import {
  getCornerSize,
  getCornerX,
  getCornerY,
  isValidRowCol,
  parseRowColString,
  type KarelEnvironment,
} from '../util';

interface PaintProps {
  state: KarelEnvironment;
}

interface PaintedCornerProps {
  r: number;
  c: number;
  color: string;
  state: KarelEnvironment;
}

export const Paint = ({state}: PaintProps) => {
  const paintData = state.worldState.paint;

  // do nothing if beepers are not defined
  if (!paintData) {
    return <></>;
  }
  return (
    <div>
      {Object.keys(paintData).map(rowColKey => {
        const [row, col] = parseRowColString(rowColKey);
        if (!isValidRowCol(state, row, col)) {
          return null;
        }
        const color = paintData[rowColKey];
        return (
          <PaintedCorner
            r={row}
            c={col}
            color={color}
            state={state}
            key={rowColKey}
          />
        );
      })}
    </div>
  );
};

const PaintedCorner = ({r, c, color, state}: PaintedCornerProps) => {
  // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  let size = getCornerSize(state);
  // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  let offset = (getCornerSize(state) - size) / 2;
  // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  let x = getCornerX(state, r, c) + offset;
  // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  let y = getCornerY(state, r, c) + offset;

  return (
    <div
      className="karel-stone"
      style={{
        width: size,
        height: size,
        marginLeft: x,
        marginTop: y,
        backgroundColor: color,
      }}
    ></div>
  );
};
